<template>
  <nav class="navbar is-transparent" role="navigation" aria-label="main navigation">
  <div class="navbar-brand">
    <a id="logo" class="navbar-item link" href="/">
      <LogoSmall class="garlic-logo-small" />
    </a>
    <span class="navbar-item">
      garlicrocks.com
    </span>
    <div
      class="navbar-burger"
      v-bind:class="{ 'is-active': isActive }"
      v-on:click="toggleActive()"
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
  <div class="navbar-menu" v-bind:class="{ 'is-active': isActive }">
    <div class="navbar-start">

    </div>
    <div class="navbar-end">
      <a class="navbar-item link underline" href="#how-to">
        <span>How To Use</span>
      </a>
      <a class="navbar-item link underline" href="#why">
        <span>Why A Rock?</span>
      </a>
      <a class="navbar-item link underline" href="#about">
        <span>About Us</span>
      </a>
    </div>
  </div>
</nav>

</template>

<script>
import LogoSmall from '@/assets/garlic_rock_logo_small.svg';

export default {
  name: 'NavBar',
  template: '<NavBar />',
  components: {
    LogoSmall,
  },
  data() {
    return { isActive: false };
  },
  methods: {
    toggleActive: function toggleActive() {
      // eslint-disable-next-line
      this.isActive = !this.isActive;
    },
  },
};
</script>

<style lang="scss">
@import '../../static/_main';

html {
  scroll-behavior: smooth;
}

.navbar {
  z-index: 1;
  position: absolute !important;
  width: 100%;
  background-color: transparent !important;
}

.navbar,
.navbar-menu,
.navbar-item {
  color: $white !important;
  font-size: 1.2rem;
  &:hover {
    background-color: transparent !important;
  }
}

.navbar-menu {
  padding-right: 2rem;
}

.link {
  color: $white !important;
}

.garlic-logo-small {
  fill: white;
  width: 20px;
}

@keyframes Gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

// Tablet mode
@media (max-width: $desktop) {
  .navbar-menu.is-active {
    background-color: $grey-darker !important;
  }
}

// Non Tablet Mode
@media (min-width: $desktop) {
  .underline {
    &::before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      height: 2px;
      position: absolute;
      width: 100%;
      background-color: $grey-lighter;
      visibility: hidden;
      transform: scaleX(0);
      transition: all 0.3s cubic-bezier(1, 0.25, 0, 0.75) 0s;
    }

    &:hover:before {
      visibility: visible;
      transform: scaleX(1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue